import React from 'react';

const ServiceSkeletonAdmin = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array(9).fill('').map((item) => (
        <div
          key={item}
          className="bg-white rounded-2xl shadow-lg overflow-hidden transform transition-all duration-300 animate-pulse"
        >
          {/* Service Image Skeleton */}
          <div className="relative h-48 overflow-hidden bg-gray-200">
            <div className="w-full h-full bg-gray-300"></div>
          </div>

          {/* Service Content Skeleton */}
          <div className="p-6">
            {/* Title Skeleton */}
            <div className="h-6 bg-gray-200 rounded mb-3 w-4/5"></div>

            {/* Description Skeleton - Multiple lines */}
            <div className="space-y-2 mb-6">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              <div className="h-4 bg-gray-200 rounded w-4/6"></div>
            </div>

            {/* Action Buttons Skeleton */}
            <div className="flex gap-2">
              {/* View Button Skeleton */}
              <div className="flex items-center justify-center gap-2 bg-gray-200 text-gray-200 py-2 px-4 rounded-lg font-semibold w-20">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="h-4 bg-gray-300 rounded w-8"></div>
              </div>

              {/* Edit Button Skeleton */}
              <div className="flex items-center justify-center gap-2 bg-gray-200 text-gray-200 py-2 px-4 rounded-lg font-semibold w-20">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="h-4 bg-gray-300 rounded w-8"></div>
              </div>

              {/* Delete Button Skeleton */}
              <div className="flex items-center justify-center gap-2 bg-gray-200 text-gray-200 py-2 px-4 rounded-lg font-semibold w-24">
                <div className="h-4 bg-gray-300 rounded w-12"></div>
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceSkeletonAdmin;